import React, { useState } from "react";
import {
  Box, Card, CardContent, TextField, Button, Typography,
  Stack, Alert, InputAdornment, IconButton, Link, Divider,
} from "@mui/material";
import { Email, Lock, Visibility, VisibilityOff } from "@mui/icons-material";
import { alpha, useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

export default function PortalLogin_View({
  email, password, loading, error,
  onEmailChange, onPasswordChange, onSubmit,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 60%, ${alpha(theme.palette.secondary.main, 0.8)} 100%)`,
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 420, borderRadius: 4, boxShadow: "0 24px 64px rgba(0,0,0,0.2)" }}>
        <CardContent sx={{ p: 4 }}>

          {/* Header */}
          <Stack alignItems="center" spacing={1.5} mb={4}>
            <Box
              sx={{
                width: 56, height: 56, borderRadius: 3,
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: "bold", fontSize: 18, color: "primary.main",
              }}
            >
              EC
            </Box>
            <Box textAlign="center">
              <Typography variant="h5" fontWeight={700}>Portale Clienti</Typography>
              <Typography variant="body2" color="text.secondary">Ecotrade</Typography>
            </Box>
          </Stack>

          {/* Form */}
          <form onSubmit={onSubmit}>
            <Stack spacing={2.5}>
              {error && <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>}

              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={onEmailChange}
                fullWidth
                autoComplete="email"
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={onPasswordChange}
                fullWidth
                autoComplete="current-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={loading}
                sx={{ py: 1.5, borderRadius: 2, fontWeight: 600 }}
              >
                {loading ? "Accesso in corso..." : "Accedi"}
              </Button>
            </Stack>
          </form>

          <Divider sx={{ my: 2.5 }} />

          <Stack alignItems="center">
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate("/password-dimenticata")}
              underline="hover"
              sx={{ color: "text.secondary" }}
            >
              Password dimenticata?
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
